import React, { useContext } from "react";

import { RemixBuilderContext } from "./RemixBuilderContext";

const RemixBuilderSettingsSections = () => {
  const [contextData, builder, setContextData] = useContext(RemixBuilderContext);

  const SectionTagButton = (props) => {
    const section = props.section;
    const tag = props.tag;

    return (
      <span
        className="bg-white py-[1px] px-[8px] border-solid border-1 border-slate-300 rounded-xl flex items-center cursor-pointer"
      >
        {tag.name}
        <svg
          onClick={() => builder.removeSectionTag(section, tag.name)}
          width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.6654 5.33325L5.33203 10.6666M10.6654 10.6666L5.33203 5.33325" stroke="black" strokeWidth="2" strokeLinecap="round"></path>
        </svg>
      </span>
    )
  };

  const handleNextStep = () => {
    builder.goToNextStep();
  };

  return (
    <React.Fragment>
      {contextData.uploaded_sections && (
        <>
          <div
            className="remix-editor-settings-sections flex flex-column overflow-scroll grow-1 min-w-0"
          >
            <h2 className="text-[18px] font-semibold mt-15">
              Choose sections to remix
            </h2>
            <p className="text-xl text-gray-400">
              Select sections for your generated template
            </p>

            <div className="border-solid border-1 border-slate-300 rounded-xl overflow-hidden flex flex-column">
              <div className="bg-slate-100 p-5 flex items-end gap-2">
                <label className="flex items-center gap-2 justify-center cursor-pointer relative">
                  <input
                    onChange={builder.toggleAllUploadedSections}
                    checked={contextData.uploaded_sections.every((section) => section.selected)}
                    type="checkbox"
                    className="w-[24px] h-[24px] border-2 border-solid border-slate-300 rounded-[50%]"
                  />
                  <span className="text-xl">Select all sections</span>
                </label>
              </div>

              <div className="flex flex-wrap gap-3 p-3 overflow-scroll">
                {contextData.uploaded_sections.map((section, index) => (
                  <div
                    className="flex gap-2 p-3 section-selector-box w-full"
                    key={`section-selector-${index}`}
                    data-section-id={section.id}
                  >
                    <input
                      onChange={() => builder.toggleSelectSection(section)}
                      checked={section.selected}
                      type="checkbox"
                      className="w-[24px] h-[24px] border-2 border-solid border-slate-300 rounded-[50%]"
                    />
                    <div
                      className="relative border-solid border-1 border-slate-300 rounded-xl overflow-hidden flex flex-col w-full min-h-[70px]"
                      key={`section-${index}`}
                    >
                      <div className="z-[1] invisible loading-box absolute flex w-full h-full items-center justify-center bg-black opacity-[0.7]">
                        <span className="cf-loading-spinner" />
                      </div>

                      <div className="z-[1] invisible error-box absolute flex w-full h-full items-center justify-center" style={{ background: "rgba(0,0,0,0.7)" }}>
                        <span
                          onClick={handleNextStep}
                          className="bg-white py-[1px] px-[8px] border-solid border-1 border-slate-300 rounded-xl flex gap-1 items-center cursor-pointer text-xl">
                          Try Again

                          <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 640 640"><path fill="#0a0a0a" d="M500.7 138.7L512 149.4L512 96C512 78.3 526.3 64 544 64C561.7 64 576 78.3 576 96L576 224C576 241.7 561.7 256 544 256L416 256C398.3 256 384 241.7 384 224C384 206.3 398.3 192 416 192L463.9 192L456.3 184.8C456.1 184.6 455.9 184.4 455.7 184.2C380.7 109.2 259.2 109.2 184.2 184.2C109.2 259.2 109.2 380.7 184.2 455.7C259.2 530.7 380.7 530.7 455.7 455.7C463.9 447.5 471.2 438.8 477.6 429.6C487.7 415.1 507.7 411.6 522.2 421.7C536.7 431.8 540.2 451.8 530.1 466.3C521.6 478.5 511.9 490.1 501 501C401 601 238.9 601 139 501C39.1 401 39 239 139 139C238.9 39.1 400.7 39 500.7 138.7z"/></svg>
                        </span>
                      </div>

                      <img className="w-full h-full object-cover" src={`data:image/png;base64,${section.image_bytes}`} alt={`Section ${index}`} />

                      {contextData.current_user?.super_admin === true &&
                        section.tags && (
                          <div className="flex flex-wrap gap-2 text-xl items-center justify-end absolute top-0 right-0 p-2">
                            {section.tags?.map((tag, index) => (
                              <SectionTagButton key={`section-${index}-${tag?.id}`} section={section} tag={tag} />
                            ))}
                          </div>
                        )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="remix-editor-settings-buttons pt-[30px] pb-[30px] gap-4 flex justify-between">
            <div
              onClick={handleNextStep}
              className="cursor-pointer rounded-xl w-full p-[10px] border border-solid border-black bg-black flex justify-center items-center text-white gap-2 text-xl"
            >
              Next
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default RemixBuilderSettingsSections;
